import { Action, action } from 'easy-peasy';

export interface UserModel {
  info: object;
  organization: object;
  participantContribution: number;

  setParticipantContribution: Action<UserModel, any>;
  setUser: Action<UserModel, any>;
  setOrganization: Action<UserModel, any>;
}

export const user: UserModel = {
  info: {
    firstName: 'Demo',
    lastName: 'User',
    type: 'Asset Manager',
    email: 'test@distill.com',
  },
  organization: {
    name: '',
    id: '',
    logoFile: '',
  },
  participantContribution: 120,

  setParticipantContribution: action((state, payload) => {
    state.participantContribution = payload
  }),

  setOrganization: action((state, payload) => {
    state.organization = payload
  }),

  setUser: action((state, payload) => {
    state.organization = {
      name: payload.organization?.name,
      logoFile: payload.organization?.logoFile,
      id: payload.organization?.id,
    };
    state.info = {
      firstName: payload.user.firstName,
      lastName: payload.user.lastName,
      type: payload.user.type,
      email: payload.user.email,
      timezone: payload.user.timezone,
      phone: payload.user.phone,
      organization: payload.organization?.name,
    };
  }),
};

export default user;
